<template>
    <div>
        <div style="width: 50%;height: 600px;float: left;" ref="revenueAnalysis"></div>
    </div>
</template>

<script>
    import request from '../http/analysis'
    const formatTime = require('./../utils/formatTime')
    export default {
        name: "revenueAnalysis",
        mounted() {
            this.getData() // 获取图表数据
        },
        data(){
            return{
                revenueList:[]
            }
        },
        methods:{
            /*初始化饼状图*/
            initCharts(){
               // console.log('饼状图画图了');
                const myChart = this.$echarts.init(this.$refs.revenueAnalysis)
                //console.log(this.revenueList)
                /*图表配置*/
                let option = {
                    title: {
                        text: '鱼虾蟹收益占比',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'right',
                        data: ['螃蟹', '青虾', '鱼', '其他'],
                        textStyle:{
                            fontSize: 16
                        }
                    },
                    series: [
                        {
                            name: '收益占比',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '60%'],
                            data: this.revenueList,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            label: {
                                normal: {
                                    show: true,
                                    textStyle: {
                                        fontSize: 16
                                    }
                                }
                            },
                        }
                    ]
                }
                /*绘制图表*/
                myChart.setOption(option)
            },
            /*获取图表数据*/
            async getData(value){
               // console.log(value);
                let dateObj = {
                    endDate:'',
                    startDate:''
                }
                if (value){
                    dateObj.endDate = value[1];
                    dateObj.startDate = value[0]
                }else{
                    dateObj.endDate = formatTime(0)//当前时间
                    dateObj.startDate = formatTime(-365)//七天前
                }

                request.getRevenueAnalysisData(dateObj).then(res => {
                    console.log('饼状图',res)
                    let result = res.data.data.dataListDtos
                    console.log(result)
                    let  len = result.length;
                    for (let i =0; i < len; i++){
                        if (result[i] == null){
                            result.shift()
                        }
                    }
                    if (result.length){
                        console.log(1);
                        this.revenueList = result
                    }else {
                        console.log(2);
                        this.revenueList = [{name: "数据为空", value: 0}]
                    }
                    this.initCharts() // 获取数据之后再初始化图表
                })
            }
        }
    }
</script>

<style scoped>

</style>
